export const NODE_PROTOCOL_VERSION = 1;
export const NODE_CAPABILITIES = [
    "terminal",
    "filesystem",
    "screen",
    "voice",
    "browser",
    "camera",
    "network",
];
//# sourceMappingURL=node.js.map